import './AbookItemAvatar.scss';
import clsx from 'clsx';
import UserAvatar from '@molecules/UserAvatar/UserAvatar';
import { useAvatarMeta } from '@molecules/UserAvatar/useAvatarMeta';
import { IAddressBookData } from '@models/addressbook/IAddressBookData';
import { isAbookPerson } from '@models/addressbook/IPersonCard';

/** Аватар строки адресной книги: фото по метаданным пачкой, у отпуска — точка-метка. */
type IAbookAvatarItem = Pick<IAddressBookData, 'key' | 'name'> &
    Partial<Pick<IAddressBookData, 'fullName' | 'type' | 'isVacation'>>;

const AbookItemAvatar = ({ item, size }: { item: IAbookAvatarItem; size: number }) => {
    const person = isAbookPerson(item);
    const key = String(item.key);
    // пока метаданных нет — инициалы, без запроса фото
    const meta = useAvatarMeta(person ? key : undefined);
    return (
        <span
            className={clsx('rf-abook-avatar', person && item.isVacation && 'rf-abook-avatar--away')}
            aria-hidden="true"
        >
            <UserAvatar
                userKey={key}
                name={item.fullName || item.name}
                type={item.type}
                hasImage={meta?.hasImage ?? false}
                photoVersion={meta?.photoVersion ?? undefined}
                size={size}
            />
        </span>
    );
};

export default AbookItemAvatar;
